$(document).ready(function () {
  let mobileMenu = $('.js-mobile-menu');
  $('.js-toggle-menu').on('click', function () {
      $(this).toggleClass('active');
      mobileMenu.toggleClass('active');
      $('body').toggleClass('scroll-dis'); 
  });
});